var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.848 46.0027H21.1389C16.7988 46.0027 13.3 42.504 13.3 38.1638C13.3 33.8679 16.7988 30.325 21.1389 30.325H58.3403C65.8249 30.325 71.848 36.3923 71.848 43.8326V46.0027Z",
    fill: "#284993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9585 22.1761V20.1389C46.9585 15.7987 43.4598 12.3 39.1196 12.3C34.8237 12.3443 31.325 15.843 31.325 20.1389V22.1318H46.9585V22.1761Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo-3.641a15f91506ac3cf5e20998e01a6ffc.svg";
export { ForwardRef as ReactComponent };